import { Clock, CheckCircle, XCircle } from "lucide-react";
import type { AcceptanceStatus } from "../types";
import { ACCEPTANCE_STATUS_LABELS, ACCEPTANCE_STATUS_COLORS } from "../types";

interface AcceptanceStatusBadgeProps {
  status: AcceptanceStatus;
  showIcon?: boolean;
}

const STATUS_ICONS: Record<AcceptanceStatus, typeof Clock> = {
  pending: Clock,
  accepted: CheckCircle,
  rejected: XCircle,
};

export function AcceptanceStatusBadge({
  status,
  showIcon = true,
}: AcceptanceStatusBadgeProps) {
  const Icon = STATUS_ICONS[status];
  const label = ACCEPTANCE_STATUS_LABELS[status];
  const colorClass = ACCEPTANCE_STATUS_COLORS[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}
    >
      {showIcon && <Icon className="h-3 w-3" />}
      {label}
    </span>
  );
}
